'use client';

import { useEffect } from 'react';
import { Button } from '@paypoteam/ui-components/Button';
import { P } from '@paypoteam/ui-components/P';
import * as Sentry from '@sentry/nextjs';

import { LocalImage } from '@/components/atoms/LocalImage';
import H2 from '@/components/atoms/Typography/H2';
import Section from '@/components/layout/Section';

import { env } from '@/env.mjs';

interface ErrorPageProps {
    error?: Error & { digest?: string };
    reset: () => void;
}

const content = {
    RO: {
        title: 'Ceva a mers greșit',
        description: 'A apărut o eroare neașteptată. Încearcă din nou.',
        button: 'Încearcă din nou',
    },
    PL: {
        title: 'Coś poszło nie tak',
        description: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
        button: 'Spróbuj ponownie',
    },
};

export function ErrorPage({ error, reset }: ErrorPageProps) {
    useEffect(() => {
        if (error) Sentry.captureException(error);
    }, [error]);

    const config =
        env.NEXT_PUBLIC_APP_COUNTRY === 'RO' ? content.RO : content.PL;

    return (
        <Section containerClassName="flex flex-col items-center">
            <LocalImage
                src="/images/graphics/404.svg"
                alt="error"
                width={230}
                height={230}
                className="mb-12 object-contain md:h-[300px] md:w-[300px]"
            />

            <H2 className="heading-spaces">{config.title}</H2>

            <P className="text-center">{config.description}</P>

            <Button
                onClick={reset}
                variant="outline"
                className="mt-8 w-full sm:w-fit md:mt-10"
            >
                {config.button}
            </Button>
        </Section>
    );
}
